/**
 * Created by Rodrigo Quesada on 09/05/17.
 */
import {IdentifiedModel} from '../../common/identified-model.class';
import {ModelMixin} from '../../common/model.class';

export class ActivityLogs extends ModelMixin() implements IdentifiedModel<ActivityLogs> {

    TYPE = ActivityLogs;

    id: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/activity-logs/activity-logs.model.ts